var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-menu"},[_c('List',{attrs:{"name":_vm.name,"fields":_vm.fields,"max-levels":2,"item-label":"{linkText}","add-item-label":"Adicionar item ao menu"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }